import API from "Classes/Api";
import {
  ApiGetCallParams,
  ApiPostCallParams,
  ApiPutCallParams,
  ApiDeleteCallParams,
} from "Classes/ApiCallParams";

class WisdomAdvisor extends API {
  async question({ clientId, payload }) {
    const result = await super.call(
      new ApiPostCallParams({
        action: `clients/${clientId}/wisdom-advisor/question`,
        headers: { ...API.getAuthHeaders() },
        body: payload,
        failureMessage: "Failed to fetch data.",
      })
    );

    return result;
  }

  async getConversations({ clientId }) {
    const result = await super.call(
      new ApiGetCallParams({
        action: `clients/${clientId}/wisdom-advisor/conversations?limit=10`,
        headers: { ...API.getAuthHeaders() },
        failureMessage: "Failed to fetch data.",
      })
    );

    return result;
  }

  async getSingleConversation({ clientId, conversationId }) {
    const result = await super.call(
      new ApiGetCallParams({
        action: `clients/${clientId}/wisdom-advisor/conversations/${conversationId}`,
        headers: { ...API.getAuthHeaders() },
        failureMessage: "Failed to fetch data.",
      })
    );

    return result;
  }

  async updateSingleConversation({ clientId, conversationId, payload }) {
    const result = await super.call(
      new ApiPutCallParams({
        action: `clients/${clientId}/wisdom-advisor/conversations/${conversationId}`,
        headers: { ...API.getAuthHeaders() },
        body: payload,
        failureMessage: "Failed to update data.",
      })
    );

    return result;
  }

  async deleteSingleConversation({ clientId, conversationId }) {
    const result = await super.call(
      new ApiDeleteCallParams({
        action: `clients/${clientId}/wisdom-advisor/conversations/${conversationId}`,
        headers: { ...API.getAuthHeaders() },
        failureMessage: "Failed to fetch data.",
      })
    );

    return result;
  }

  async rateAnswer({ clientId, payload }) {
    const result = await super.call(
      new ApiPostCallParams({
        action: `clients/${clientId}/wisdom-advisor/answer-rating`,
        headers: { ...API.getAuthHeaders() },
        body: payload,
        failureMessage: "Failed to update data.",
      })
    );

    return result;
  }

  async getSuggestedPrompts({ clientId, useCase, tag = "default" }) {
    const result = await super.call(
      new ApiGetCallParams({
        action: `clients/${clientId}/wisdom-advisor/usecases/${useCase}/suggested-prompts`,
        headers: { ...API.getAuthHeaders() },
        query: { tag },
      })
    );

    return result;
  }
}

const instance = new WisdomAdvisor();
export default instance;
